import React from 'react'
import styled from 'styled-components'
import Button from 'components/lib/Button'
import Modal from 'components/lib/Modal'

const Container = styled.div`
  text-align: center;
`

const CheckIcon = styled.div`
  width: 40px;
  height: 40px;
  background-color: #25dc27;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
  font-size: 24px;
  font-weight: 900;
`

const Title = styled.h2`
  margin-bottom: 20px;
  color: #333;
  font-size: 1rem;
  font-weight: 700;
`

const Message = styled.p`
  margin-bottom: 20px;
  font-size: 1em;
  color: #333;
  text-align: center;
`

const CloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`

const ExtraBillingCreatedModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <CheckIcon>✓</CheckIcon>
        <Title>Envio concluído!</Title>

        <Message>
          O cliente receberá uma mensagem no email cadastrado com as informações do
          pedido. Você pode acompanhar o status da cobrança pela aba de Posse do
          pedido.
        </Message>

        <CloseButtonContainer>
          <Button isNeutral onClick={onClose}>
            Fechar
          </Button>
        </CloseButtonContainer>
      </Container>
    </Modal>
  )
}

export default ExtraBillingCreatedModal
